import { render, staticRenderFns } from "./ActorRoleShowScreen.vue?vue&type=template&id=1a2c6f88&"
import script from "./ActorRoleShowScreen.vue?vue&type=script&lang=js&"
export * from "./ActorRoleShowScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports